/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpApprovalListRequests } from "../funcs/mcpApprovalListRequests.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListApprovalRequestsResult } from "../models/components/listapprovalrequestsresult.js";
import {
  ListMcpApprovalRequestsRequest,
  ListMcpApprovalRequestsSecurity,
} from "../models/operations/listmcpapprovalrequests.js";
import { unwrapAsync } from "../types/fp.js";
export type ListMcpApprovalRequestsQueryData = ListApprovalRequestsResult;

export function prefetchListMcpApprovalRequests(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMcpApprovalRequestsRequest | undefined,
  security?: ListMcpApprovalRequestsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListMcpApprovalRequestsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListMcpApprovalRequestsQuery(
  client$: GramCore,
  request?: ListMcpApprovalRequestsRequest | undefined,
  security?: ListMcpApprovalRequestsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListMcpApprovalRequestsQueryData>;
} {
  return {
    queryKey: queryKeyListMcpApprovalRequests({
      status: request?.status,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listMcpApprovalRequestsQueryFn(
      ctx,
    ): Promise<ListMcpApprovalRequestsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpApprovalListRequests(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListMcpApprovalRequests(
  parameters: {
    status?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpApproval", "listRequests", parameters];
}
